module.exports = __webpack_public_path__ + "static/media/pin_red.4f699d52.svg";